import { Controller, useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { SimpleDropdown } from "@circle-react/components/shared/uikit/SimpleDropdown";

export interface DurationSelectProps {
  dataTestId?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  name: string;
}

interface DurationSelectOption {
  label: string;
  value: number;
}

export const DurationSelect = ({
  name,
  disabled,
  fullWidth,
  dataTestId,
}: DurationSelectProps) => {
  const { control } = useFormContext();
  const options: DurationSelectOption[] = [
    {
      label: `15 ${t("minutes")}`,
      value: 900,
    },
    {
      label: `30 ${t("minutes")}`,
      value: 1800,
    },
    {
      label: `45 ${t("minutes")}`,
      value: 2700,
    },
    {
      label: `1 ${t("hour")}`,
      value: 3600,
    },
  ];

  for (let i = 1.5; i < 24; i = i + 0.5) {
    const element = {
      label: `${i} ${t("hours")}`,
      value: i * 3600,
    };
    options.push(element);
  }

  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, value },
      }: {
        field: {
          onChange: (value: string | number) => void;
          value: string | number;
        };
      }) => (
        <SimpleDropdown
          fullWidth={fullWidth}
          value={value}
          menuItems={options}
          onChange={onChange}
          disabled={disabled}
          dataTestId={dataTestId}
        />
      )}
    />
  );
};

DurationSelect.displayName = "Form.DurationSelect";
